// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__VQKnG","menuButton":"PageHeader_menuButton__Q4Qes","content":"PageHeader_content__XB9pX","right":"PageHeader_right__djl06"};